import {requestAnimationFrame} from 'CommonUtils/raf.js';
import { localSaveRaw, localLoadRaw } from '../../storageService';
import { logMessage } from '../../js/common/logger';
import {content} from './chat-content';
import {fetchAndStream, answer_time} from './stream';

const env = window.readcookie(ENV_COOKIE) || API_ENV;
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const errorCode = urlParams.get('error_code') && decodeURIComponent(urlParams.get('error_code'))   || '';
let lang = languageAttributes.spokenLanguageCode;

let isMob = window.innerWidth < 768 && "ontouchstart" in document.documentElement ? true : false;

const hp_question = localLoadRaw('iforexai-hpq') || '';

let chat_exp = localLoadRaw(`chatAi_exp_${lang}`);
let chatAi_countQ = localLoadRaw(`chatAi_countQ_${lang}`);
let threadId = localLoadRaw(`chatAi_threadId_${lang}`) || '';


let chatContainer = document.getElementById('chat-ai');
let loader = document.getElementById('ai-loader');
let aiInput = document.getElementById("ai-question-input");
let aiIputWrapper =  document.querySelector(".ai-question-input-wrapper");
let main_banner =  document.querySelector(".main-banner");
let main_header = document.getElementById("main-header");
let submitButton = document.getElementById("ai-submit");
let ChatList = document.getElementById("all-messages");
let cookie_notif = document.getElementById("cookie-notif");

let aiInputVal = hp_question || '';	
let count_questions = 0 ;
count_questions = chatAi_countQ ? chatAi_countQ*1 : 0 ;

let typing_active = false;



let aiContent = content[lang] || content.en;

let aiLandCode = lang;

let hi_hi = false;

switch (lang) {
    case 'ko':
        aiLandCode = 'kr';
        break;
    case 'es':
        aiLandCode = 'sp';
        break;
    case 'hi':
        aiLandCode = 'hi';
        hi_hi = true;
        break;
    default:
        break;
}


let errorsObj =
{   
    400: aiContent.error_msg_400,
    408: aiContent.error_msg_408,
    general : aiContent.error_msg
}

let errorText = errorsObj.general;

function fadeIn(element, duration) {
    element.style.opacity = 0;
    let startTime = null;

    function animate(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = ease(timeElapsed, 0, 1, duration);
        element.style.opacity = run;
        
        if (timeElapsed < duration) {
            requestAnimationFrame(animate);
        }
    }

    function ease(t, b, c, d) {
        t /= d;
        return -c * t*(t-2) + b;
    };

    requestAnimationFrame(animate);
}
/*
function typeWriter(span, text) {
    let index = 0;
    let html = '';


    function type() {
        
        let li_elements = document.querySelectorAll('#all-messages li.ai:not(.limit)');
        let lastLiTop = chatContainer.offsetTop + li_elements[li_elements.length - 1].offsetTop;
        
        if (index < text.length) {
            typing_active = true;
            if (text.substr(index, 4) === '<br>') {
                html += '<br>';
                span.innerHTML = html; // Insert <br> tag as HTML
                index += 4; // Skip the <br> tag
            } else if (text.substr(index, 4) === '<a href=') {
                const endIndex = text.indexOf('</a>', index) + 1;
                html += text.substring(index, endIndex); // Insert <a> tag as HTML
                index = endIndex; // Skip the <a href=...> tag
            } else {
                html += text.charAt(index);
                span.innerHTML = html;
                index++;
            }
    
            if ( isMob && lastLiTop > 100) {

                window.scrollTo({
                    top: lastLiTop -100,
                    behavior: 'smooth'
                });
            }
    
            setTimeout(type, 10); // Adjust the typing speed here

        }else{
            typing_active = false;
            let limit = document.querySelectorAll('.limit')[0];
            limit && fadeIn(limit,1000)
        }
    }
    type();
}
*/


function setMessage(type,text){


    let message_class = type == 'question' ? 'user' : 'ai';
    let li = document.createElement('li');
    
    li.classList.add(message_class);
    type === 'stopChat' && li.classList.add('limit');
    li.innerHTML =  type === 'stopChat' ? 
                            `<p id="stopChat">
                                <span class="name"></span><br>
                                <span class="limit-text">${aiContent.thank_you_msg}</span>
                            </p>` :
                            !text ? `<p>
                                <span class="name"></span><br>
                                <span class="typing"><span></span><span></span><span></span></span>
                                <span class="text pending-answer"></span>
                            </p>` :
                            `<p>
                                <span class="name"></span><br>
                                <span class="text">${text}</span>
                            </p>`;
    
    requestAnimationFrame(()=>{ 
        
        ChatList.appendChild(li);

        if(!typing_active || type == 'question'){


            fadeIn(li, 1000);

             /*isMob &&  window.scrollTo({
                top: chatContainer.clientHeight - window.innerHeight + 100,
                behavior: 'smooth'
            });*/
        }
        
    });
}


export function getDate(){
    const now = new Date();

    const options = {
    timeZone: 'GMT',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
    };

    const formattedDate = now.toLocaleString('en-US', options).split(',')[0];
    const formattedTime = now.toLocaleString('en-US', options).split(',')[1].trim();

    return  `${formattedDate} ${formattedTime}`;
}


function setLogMessage(response, q_date, a_date){

    let details = response ? response.details : '';
    
    if(response.output ){

        logMessage({
            eid : 'AIPrompt',
            chat_id : threadId, 
            chat_question:aiInputVal,
            chat_question_date: q_date,
            chat_answer:response.output.replace(/<br\s*\/?>/gi,' '),
            chat_answer_date:a_date,
            chat_device : isMob ? 'mobile' : 'desktop',
            ai_response :  JSON.stringify(response),
            chat_q_count : count_questions*1,
            lang : hi_hi ? 'hi' : aiLandCode
        })

    }else{
        logMessage({
            eid : 'AI_Error',
            chat_question : aiInputVal,
            chat_id : threadId, 
            chat_error_code : details ? details.httpStatus : 'no error details',
            chat_error_message :  details ? details.error  : 'no error details',
            chat_date_time : getDate(),
            chat_device : isMob  ? 'mobile' : 'desktop',
            ai_response :  JSON.stringify(response),
            chat_q_count : count_questions*1 + 1,
            lang : hi_hi ? 'hi' : aiLandCode

        }) 
    }
}

function setLogBlocked(eid, text){
    logMessage({
        eid : eid,
        chat_id : threadId, 
        chat_error_code : 0,
        chat_question : text,
        chat_date_time : getDate(),
        chat_device : isMob  ? 'mobile' : 'desktop',
        chat_q_count : count_questions*1,
        lang : hi_hi ? 'hi' : aiLandCode
    }) 
}
/*
async function askGPT(){

    let query = {
        input: decodeURIComponent(aiInputVal),
        lang: aiLandCode
    }

    if(threadId){query.threadId = threadId}
      
    try {
        const response = await fetch(`https://content.webapi-services.net/api/askAI?env=${env}`, {
          method: "POST", 
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(query),
        });
    
        const result = await response.text();
        
        return(result)

      } catch (error) {

        logMessage({
            eid : 'AI_Error',
            chat_question : aiInputVal,
            chat_id : threadId , 
            chat_error_id : error.code,
            chat_error_message : error,
            chat_date_time : getDate(),
            chat_device : isMob ? 'mobile' : 'desktop',
            chat_q_count : count_questions*1+1,
            lang : hi_hi ? 'hi' : aiLandCode

        }) 
        
        errorText = error.code && (error.code in errorsObj) ? errorsObj[error.code] : errorText;

        setAnswer(errorText, true)
        return false;
      }   
    
}
*/
function disableInput(){
    aiInput.placeholder = "";
    aiInput.disabled = true;
    aiInput.value = '';
    submitButton.classList.add('disabled');

}

function enableInput(){
    aiInput.placeholder = aiContent.placeholder;
    aiInput.disabled = false;
}

function stopChat(type){

    disableInput();
    if(type !== 'error') {
        setMessage('stopChat');
        let now = new Date();
        let expiryTime = chat_exp || now.getTime() + 1 * 60 * 60 * 1000; 
        localSaveRaw(`chatAi_exp_${lang}`,expiryTime)
    } 
    
    
}


function generateText(text) {

    let replacedText = text
    .replace(/\n/g, '<br>')  // Convert newlines to line breaks
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')  // Bold text
    .replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2">$1</a>');  // Convert markdown links to HTML links


    return replacedText;
  

}

function setQuestion(){
    
    disableInput();
    
    setMessage('question' , aiInputVal);

    if ( isMob ) {

        window.scrollTo({
            top: chatContainer.offsetTop + chatContainer.clientHeight - 200,
            behavior: 'smooth'
        });
    }

    setMessage('answer');
}

function setAnswer(text, response_error){

    let pending_elem = document.querySelector('.pending-answer');
    let typing = document.querySelector('.typing');

     requestAnimationFrame( ()=> {
    
        typing && typing.remove(); 
        pending_elem.innerHTML = text ;
        
    });

    response_error && pending_elem.classList.add('error');
    
    pending_elem.classList.remove('pending-answer');
    enableInput();
}

async function submitInput(){

    let question_time = getDate();
    let response_error = false;

    if(aiInputVal.trim() !== ""){

        setQuestion();

        let answer = await fetchAndStream(aiInputVal, aiLandCode, threadId);

        setTimeout(() => {
            if(!answer){
                setAnswer(errorText, true);
                stopChat( 'error');
                setLogMessage('no server response timeout')
            }
        }, 10000);


        if(answer){

            const regex = /(\{.*?\})(?=\{|\s*$)/g;

            // Match and parse each JSON object
            const jsonObjects = answer.match(regex).map(obj => JSON.parse(obj));
            let run_info_chunck = jsonObjects.find(obj => obj.type === "runInfo");

            let jsonObj = run_info_chunck.data;

            let output = jsonObj ? jsonObj.output : '';
            let details = jsonObj ? jsonObj.details : ''

            if(threadId.length === 0) {
                threadId = jsonObj && jsonObj.threadId ? jsonObj.threadId : '';
                localSaveRaw(`chatAi_threadId_${lang}`, threadId)
            }

            response_error = !output ? true : false;
            
            !response_error && count_questions ++;
            
            setLogMessage(jsonObj, question_time, answer_time);
            
            let text  = output ? generateText(output) : errorText;

            setAnswer(text, response_error)


            localSaveRaw(`chatAi_countQ_${lang}`,count_questions);

            (response_error || count_questions >= 4) && stopChat(response_error ? 'error' : '');

            count_questions >= 4 && setLogBlocked('AIChatLocked', aiInputVal);
            
            
        }
    }
}

function checkInputA() {

    aiInputVal = aiInput.value;
    aiInputVal.trim() !== "" ? submitButton.classList.remove('disabled') : submitButton.classList.add('disabled');

}

function stickyInput(){

    window.addEventListener('scroll', function() {

        let input_fixed_bottom = cookie_notif && cookie_notif.style.display === 'block' ? cookie_notif.offsetHeight : 0;
        
        let windowHeight = window.innerHeight - input_fixed_bottom - main_header.offsetHeight || document.documentElement.clientHeight;
        let elementHeight = chatContainer.scrollHeight;
       
        let rect = chatContainer.getBoundingClientRect();
        let bottomPosition = rect.bottom - 70;
        let topPosition = rect.top + 100;

        if( (bottomPosition > windowHeight && topPosition < windowHeight)){
            chatContainer.classList.add('sticky-input');
            aiIputWrapper.style.bottom = input_fixed_bottom + 'px';

        }else{

            chatContainer.classList.remove('sticky-input');
            aiIputWrapper.style.bottom = '0px';
        }
        
    })

}

function checkIfChatBlocked(){
    let now = new Date();
    if ( now.getTime() > chat_exp ) {
        count_questions = 0;
        try {
            localStorage.removeItem('chatAi_exp');
            localStorage.removeItem('chatAi_countQ');
        } catch (error) {
            
        }
        
        hp_question ? submitInput() : enableInput();
    }else{
         setTimeout(() => {
            hp_question ? setLogBlocked('AIChatLocked-hpBanner', hp_question) : setLogBlocked('AIChatLocked', aiInputVal);
            setMessage('stopChat');
          }, "2000");
        disableInput();
    }
}

window.onbeforeunload = function () {
    window.scrollTo(0, 0);
};

window.onload = function () {

    if(errorCode !== '') {
        // add error_code param to url to test errors
        errorText = (errorCode in errorsObj) ? errorsObj[errorCode] : errorText;

        ChatList.innerHTML = `<li class="ai" style="opacity: 1;"><p>
                                 <span class="name"></span><br>
                                <span class="text error">${errorText}</span>
                            </p></li>`;
        logMessage({
            eid : 'AI_Error_test',
            chat_question : aiInputVal,
            chat_id : threadId , 
            chat_error_id : errorCode,
            chat_error_message : errorsObj[errorCode],
            chat_date_time : getDate(),
            chat_device : isMob ? 'mobile' : 'desktop',
            chat_q_count : count_questions*1,
            lang : hi_hi ? 'hi' : aiLandCode

        }) 
        
        }



        
    chatContainer.style.display='block';
    loader.style.display='none';
  


    submitButton.addEventListener("click", submitInput);
    aiInput.addEventListener("input", checkInputA);
    
    aiInput.addEventListener('keydown', (event) => {
        event.key === 'Enter' && aiInput.value.trim() !== "" && submitInput();
    });

    count_questions >= 4 || chat_exp ? checkIfChatBlocked() : hp_question ? submitInput() : '';

    if(hp_question){
        
        try {
            localStorage.removeItem("iforexai-hpq");
        } catch (error) {
            console.log(error)
        }
        
    }




    isMob && stickyInput();
    
}


